import { render, staticRenderFns } from "./personShopInfo.vue?vue&type=template&id=4967ba5c&scoped=true"
import script from "./personShopInfo.vue?vue&type=script&lang=js"
export * from "./personShopInfo.vue?vue&type=script&lang=js"
import style0 from "./personShopInfo.vue?vue&type=style&index=0&id=4967ba5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4967ba5c",
  null
  
)

export default component.exports